import { useRef, useEffect } from "react";
import {
  PlayFill,
  PauseFill,
  VolumeDown,
  VolumeMute,
  Fullscreen,
} from "react-bootstrap-icons";
import { Base } from "../RootLayout";
import TopNavigation from "../TopNavigation";
import * as Assets from "../../utils/svg_assets";
import useVideoPlayer from "../../hooks/useVideoPlayer";
import ZoomModal from "./Zoom";
import ApiUtils from "../../utils/api_utils";
import "./style.scss";

const ModalZoom = (props) => {
  const { handleClose = () => {}, data, open } = props;

  const videoElement = useRef(null);

  const {
    playerState,
    togglePlay,
    handleOnTimeUpdate,
    handleVideoProgress,
    handleVideoSpeed,
    toggleMute,
  } = useVideoPlayer(videoElement);

  useEffect(() => {
    playerState.isPlaying = true;
  }, []);

  const toggleFullScreen = () => {
    let el = document.getElementById("full-screenVideo");
    if (el.requestFullscreen) {
      el.requestFullscreen();
    } else if (el.msRequestFullscreen) {
      el.msRequestFullscreen();
    } else if (el.mozRequestFullScreen) {
      el.mozRequestFullScreen();
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    }
  };

  return (
    <Base bgColor={"#000000"}>
      <TopNavigation
        titlePage={null}
        setBorder={false}
        showRightIcon={false}
        iconLeft={Assets.iconClose}
        onClick={handleClose}
      />
      <div>
        {data[0]?.video ? (
          <div className="container-video">
            <div className="video-wrapper">
              <video
                id="full-screenVideo"
                src={ApiUtils.validateImgUrl({ url: data[0].video })}
                ref={videoElement}
                onTimeUpdate={handleOnTimeUpdate}
                style={{ width: "100%", height: "100%" }}
              />
              <div className="controls">
                <div className="actions">
                  <button onClick={togglePlay}>
                    {!playerState.isPlaying ? (
                      <PlayFill size={25} />
                    ) : (
                      <PauseFill size={25} />
                    )}
                  </button>
                </div>
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={playerState.progress}
                  onChange={(e) => handleVideoProgress(e)}
                />
                <select
                  className="velocity"
                  value={playerState.speed}
                  onChange={(e) => handleVideoSpeed(e)}
                >
                  <option value="0.50">0.50x</option>
                  <option value="1">1x</option>
                  <option value="1.25">1.25x</option>
                  <option value="2">2x</option>
                </select>
                <button className="mute-btn" onClick={toggleMute}>
                  {!playerState.isMuted ? (
                    <VolumeDown size={25} />
                  ) : (
                    <VolumeMute size={25} />
                  )}
                </button>
                <div onClick={toggleFullScreen}>
                  <Fullscreen />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <ZoomModal open={open} toggle={handleClose} data={data} />
        )}
      </div>
    </Base>
  );
};

export default ModalZoom;
